import { Action } from '@ngrx/store'
import * as DiscountGroupsTypes from './discount-groups.types'
import { DiscountGroup } from './discount-groups.interface'

// Fetch DiscountGroup Types
export class FetchDiscountGroupsRequest implements Action {
  readonly type = DiscountGroupsTypes.FETCH_DISCOUNT_GROUPS_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchDiscountGroupsSuccess implements Action {
  readonly type = DiscountGroupsTypes.FETCH_DISCOUNT_GROUPS_SUCCESS
  constructor(
    public payload: DiscountGroup[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchDiscountGroupsFailure implements Action {
  readonly type = DiscountGroupsTypes.FETCH_DISCOUNT_GROUPS_FAILURE
  constructor(public payload: any) {}
}

// Fetch DiscountGroup Type
export class FetchDiscountGroupRequest implements Action {
  readonly type = DiscountGroupsTypes.FETCH_DISCOUNT_GROUP_REQUEST
  constructor(public id: number) {}
}

export class FetchDiscountGroupSuccess implements Action {
  readonly type = DiscountGroupsTypes.FETCH_DISCOUNT_GROUP_SUCCESS
  constructor(public payload: DiscountGroup) {}
}

export class FetchDiscountGroupFailure implements Action {
  readonly type = DiscountGroupsTypes.FETCH_DISCOUNT_GROUP_FAILURE
  constructor(public payload: any) {}
}

// Delete DiscountGroup Type
export class DeleteDiscountGroupRequest implements Action {
  readonly type = DiscountGroupsTypes.DELETE_DISCOUNT_GROUP_REQUEST
  constructor(public id: number) {}
}

export class DeleteDiscountGroupSuccess implements Action {
  readonly type = DiscountGroupsTypes.DELETE_DISCOUNT_GROUP_SUCCESS
  constructor() {}
}

export class DeleteDiscountGroupFailure implements Action {
  readonly type = DiscountGroupsTypes.DELETE_DISCOUNT_GROUP_FAILURE
  constructor(public payload: any) {}
}

// Create DiscountGroup Type
export class CreateDiscountGroupRequest implements Action {
  readonly type = DiscountGroupsTypes.CREATE_DISCOUNT_GROUP_REQUEST
  constructor(public payload) {}
}

export class CreateDiscountGroupSuccess implements Action {
  readonly type = DiscountGroupsTypes.CREATE_DISCOUNT_GROUP_SUCCESS
  constructor() {}
}

export class CreateDiscountGroupFailure implements Action {
  readonly type = DiscountGroupsTypes.CREATE_DISCOUNT_GROUP_FAILURE
  constructor(public payload: any) {}
}

// Update DiscountGroup Type
export class UpdateDiscountGroupRequest implements Action {
  readonly type = DiscountGroupsTypes.UPDATE_DISCOUNT_GROUP_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateDiscountGroupSuccess implements Action {
  readonly type = DiscountGroupsTypes.UPDATE_DISCOUNT_GROUP_SUCCESS
  constructor() {}
}

export class UpdateDiscountGroupFailure implements Action {
  readonly type = DiscountGroupsTypes.UPDATE_DISCOUNT_GROUP_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = DiscountGroupsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = DiscountGroupsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateDiscountGroupRequest
  | UpdateDiscountGroupSuccess
  | UpdateDiscountGroupFailure
  | FetchDiscountGroupsSuccess
  | FetchDiscountGroupsFailure
  | FetchDiscountGroupsRequest
  | FetchDiscountGroupSuccess
  | FetchDiscountGroupFailure
  | FetchDiscountGroupRequest
  | CreateDiscountGroupRequest
  | CreateDiscountGroupSuccess
  | CreateDiscountGroupFailure
  | DeleteDiscountGroupRequest
  | DeleteDiscountGroupSuccess
  | DeleteDiscountGroupFailure
  | SetDefaultData
  | UpdateField
  | FetchDiscountGroupsRequest
  | FetchDiscountGroupsSuccess
  | FetchDiscountGroupsFailure
